<template>
	<div>
		<div
			v-if="!isLoadingDatiGameday"
			class="gameday_body"
			@click.right="handlePrevent"
			@copy="handlePrevent"
			@paste="handlePrevent"
		>
			<header>
				<div class="d-flex justify-space-between">
					<div>
						<img alt="logo" src="https://app.simulatoreclickday.it/img/LogoInail.png">
					</div>
					<div v-if="status == 'only_view_mode'">
						<input
							@click="goBack()"
							:disabled="isLeftingSimulazione"
							type="button"
							value="Esci"
							class="btn"
						>
					</div>
				</div>
			</header>

			<div class="main">
				<div style="padding-left:5px">
					<template v-if="status == 'not_started' || errorMessage">
						<div class="titolo">
							<span v-if="nomeGameday">{{ nomeGameday }} - Convalida Domanda</span>
						</div>

						<div style="padding-left:5px">
							<div class="form-gray py-10">
								<template v-if="errorMessage">
									<div class="mb-2" :style="`font-weight: 500; color: ${scdRed}`">{{ errorMessage }}</div>
								</template>
								<template v-else>
									<div
										class="mb-2"
										style="font-weight: 500"
									>
										L'invio della domanda potrà essere effettuato il giorno <b>{{ dateITFormatDDMMYYYY(annoMeseGiornoSimulazione) }}</b> a partire dalle ore <b>{{ computedTimeWithoutSeconds(datiSimulazione.dataOra) }}</b></div>
									<div style="font-weight: 500">Cliccare sul pulsante RICARICA per effettuare il refresh della pagina.</div>
								</template>
								<div>
									<input
										@click="goBack()"
										type="button"
										value="Esci"
										title="Esci"
										class="btn mt-12"
									>
									<input
										v-if="!errorMessage"
										@click="reloadPage()"
										type="button"
										value="Ricarica"
										title="Ricarica"
										class="btn mt-12 pull-right "
									>
								</div>

							</div>
						</div>
					</template>

					<template v-else-if="status == 'started' || status == 'only_view_mode'">
						<h2>Bando ISI 2023 - Convalida e invio della domanda</h2>
						<div>* I campi contrassegnati dal simbolo * sono obbligatori.</div>
						<div class="form-gray">
							<div style="margin-bottom:40px; font-size:16px; font-weight:600;">
								INSERIMENTO DATI
							</div>
							<v-form ref="formEseguiSimulazione">
								<input type="hidden" name="_token" :value="csrf">
								<!-- <input type="hidden" name="simulazione_id" :value="simulazione.id">
								<input type="hidden" name="bando_id" :value="bandoId">
								<input type="hidden" name="anno_mese_giorno_simulazione" :value="annoMeseGiornoSimulazione"> -->

								<fieldset id="form-fieldset">
									<div style="margin-bottom:10px">Per procedere con l'invio della domanda è necessario compilare i seguenti campi:</div>
									<div style="display:inline-block;" class="simulazione-step-3 simulazione-step-5">
										<div :id="sim.id" v-for="(sim, index) in datiSimulazione.simulazione" :key="sim.id" :class="`${sim.rispostaNonCorretta ? 'errore ' : ''} form-elem xs-12 md-6`">
											
											<label v-if="sim.tipo != 'checkbox'
												&& sim.tipo != 'checkbox_reverse'
												&& sim.tipo != 'checkbox_bloccante'
												&& sim.tipo != 'summary'
												&& sim.show"
											>
												<span v-if="sim.tipo != 'tooltip'" v-html="sim.domanda"></span>
												<span v-else-if="sim.tipo == 'tooltip'">Posizionare il mouse sull'icona (<v-icon color="primary" small>mdi-key</v-icon>) per vedere il codice</span>
												<span> *</span>
											</label>

											<img v-if="sim.tipo == 'image' && sim.show" src="/img/clickday/captcha.png" alt="captcha" style="height: 50px">
											<input v-if="sim.tipo == 'image' && sim.show" type="text" v-model="risposteUtente[sim.id]" :name="`risposte[${index}]`" class="form-control" autocomplete="off" tabindex="1">
											
											<img v-if="sim.tipo == 'image_gameday_4_2023' && sim.show" src="/img/clickday/captcha-gameday-4-2023.png" alt="captcha" style="height: 50px">
											<input v-if="sim.tipo == 'image_gameday_4_2023' && sim.show" type="text" v-model="risposteUtente[sim.id]" :name="`risposte[${index}]`" class="form-control" autocomplete="off" tabindex="1">

											<div v-if="sim.tipo == 'sequence' && sim.show">
												<div class="d-flex align-center mb-1">
													<div class="mr-3" style="width:160px">La quinta lettera</div>
													<input type="text" @input="buildSequence(sim.id)" v-model="sequence.char1" :style="`width:100px; box-shadow:none; border-color:${getSequenceBorderColor(sequence.char1, 1)}`" autocomplete="off" tabindex="1">
												</div>
												<div class="d-flex align-center mb-1">
													<div class="mr-3" style="width:160px">La quarta lettera</div>
													<input type="text" @input="buildSequence(sim.id)" v-model="sequence.char2" :style="`width:100px; box-shadow:none; border-color:${getSequenceBorderColor(sequence.char2, 2)}`" autocomplete="off" tabindex="1">
												</div>
												<div class="d-flex align-center mb-1">
													<div class="mr-3" style="width:160px">La terza lettera</div>
													<input type="text" @input="buildSequence(sim.id)" v-model="sequence.char3" :style="`width:100px; box-shadow:none; border-color:${getSequenceBorderColor(sequence.char3, 3)}`" autocomplete="off" tabindex="1">
												</div>
												<div class="d-flex align-center mb-1">
													<div class="mr-3" style="width:160px">La seconda lettera</div>
													<input type="text" @input="buildSequence(sim.id)" v-model="sequence.char4" :style="`width:100px; box-shadow:none; border-color:${getSequenceBorderColor(sequence.char4, 4)}`" autocomplete="off" tabindex="1">
												</div>
												<div class="d-flex align-center">
													<div class="mr-3" style="width:160px">La prima lettera</div>
													<input type="text" @input="buildSequence(sim.id)" v-model="sequence.char5" :style="`width:100px; box-shadow:none; border-color:${getSequenceBorderColor(sequence.char5, 5)}`" autocomplete="off" tabindex="1">
												</div>
												<input v-show="false" type="text" v-model="risposteUtente[sim.id]" :name="`risposte[${index}]`" class="form-control" autocomplete="off" tabindex="1">
											</div>

											<div v-if="sim.tipo == 'tooltip' && sim.show">
												<v-tooltip right color="primary">
													<template v-slot:activator="{ on, attrs }">
														<v-icon
															color="primary"
															v-bind="attrs"
															v-on="on"
														>
															mdi-key
														</v-icon>
													</template>
													<span>{{ sim.risposte[0]}}</span>
												</v-tooltip>
												<div>Scrivere il codice nel campo sottostante</div>
												<input type="text" v-model="risposteUtente[sim.id]" :name="`risposte[${index}]`" class="form-control" autocomplete="off" tabindex="1">
											</div>

											<div v-if="sim.tipo == 'hold_down' && sim.show">
												<v-tooltip right color="primary" :disabled="!showTooltip">
													<template v-slot:activator="{ on, attrs }">
														<v-btn
															rounded
															depressed
															style="text-transform:none; color:white;"
															:color="scdColor"
															@mousedown="showTooltip = true"
															@mouseup="showTooltip = false"
															@mouseleave="showTooltip = false"
															@mouseout="showTooltip = false"
															v-bind="attrs"
															v-on="on"
															class="mb-2"
														>
															<v-icon>mdi-key</v-icon>
														</v-btn>
													</template>
													<span>{{ sim.risposte[0]}}</span>
												</v-tooltip>
												<div>Scrivere il codice nel campo sottostante</div>
												<input
													type="text"
													v-model="risposteUtente[sim.id]"
													:name="`risposte[${index}]`"
													class="form-control"
													autocomplete="off"
													tabindex="1"
												>
											</div>

											<input
												v-if="sim.tipo == 'text' && sim.show"
												type="text"
												v-model="risposteUtente[sim.id]"
												:name="`risposte[${index}]`"
												class="form-control"
												autocomplete="off"
												tabindex="1"
											>

											<select
												v-else-if="sim.tipo == 'select' && sim.show"
												v-model="risposteUtente[sim.id]"
												:name="`risposte[${index}]`"
												style="-webkit-appearance: menulist; -moz-appearance: menulist; appearance: menulist;"
												tabindex="1"
											>
												<option value="" disabled selected hidden>Scegli una risposta</option>
												<option v-for="(risposta, i) in sim.risposte" :key="i" :value="risposta">{{risposta}}</option>
											</select>

											<!--<v-radio-group-->
											<!--	v-else-if="sim.tipo == 'radio' && sim.show"-->
											<!--	class="_radio_group mt-2"-->
											<!--	v-model="risposteUtente[sim.id]"-->
											<!--	:error="sim.rispostaNonCorretta"-->
											<!--&gt;-->
											<!--	<v-radio-->
											<!--		v-for="(risposta, index) in sim.risposte"-->
											<!--		:key="index"-->
											<!--		:label="risposta"-->
											<!--		:value="risposta"-->
											<!--		:color="scdColor"-->
											<!--		tabindex="1"-->
											<!--	></v-radio>-->
											<!--</v-radio-group>-->
											
											<template v-else-if="sim.tipo == 'radio' && sim.show">
												<v-row no-gutters>
													<template v-for="(risposta, index) in sim.risposte">
														<v-col cols="12">
															<div>
																<input
																	type="radio"
																	:id="`${sim.id}_${index}`"
																	:value="risposta"
																	v-model="risposteUtente[sim.id]"
																>
																<label class="radio-label" :for="`${sim.id}_${index}`">{{ risposta }}</label>
															</div>
														</v-col>
													</template>
												</v-row>
											</template>
											
											<!--<v-radio-group-->
											<!--	v-else-if="sim.tipo == 'radio_3_rows' && sim.show"-->
											<!--	class="_radio_group mt-2"-->
											<!--	style="width: 700px"-->
											<!--	v-model="risposteUtente[sim.id]"-->
											<!--	:error="sim.rispostaNonCorretta"-->
											<!--	row-->
											<!--&gt;-->
											<!--	<v-radio-->
											<!--		v-for="(risposta, index) in sim.risposte"-->
											<!--		:key="index"-->
											<!--		:label="risposta"-->
											<!--		:value="risposta"-->
											<!--		:color="scdColor"-->
											<!--		tabindex="1"-->
											<!--		style="margin-bottom: 10px"-->
											<!--	>-->
											<!--		<template v-slot:label>-->
											<!--			<div style="width: 120px">-->
											<!--				{{ risposta }}-->
											<!--			</div>-->
											<!--		</template>-->
											<!--	</v-radio>-->
											<!--</v-radio-group>-->
											
											<template v-else-if="sim.tipo == 'radio3' && sim.show">
												<v-row no-gutters>
													<template v-for="(risposta, index) in sim.risposte">
														<v-col cols="4">
															<div>
																<input
																	type="radio"
																	:id="`${sim.id}_${index}`"
																	:value="risposta"
																	v-model="risposteUtente[sim.id]"
																>
																<label class="radio-label" :for="`${sim.id}_${index}`">{{ risposta }}</label>
															</div>
														</v-col>
													</template>
												</v-row>
											</template>
											
											<!--<div-->
											<!--	v-else-if="sim.tipo == 'standard_radio_buttons_3_rows' && sim.show"-->
											<!--	class="form-group"-->
											<!--&gt;-->
											<!--	<div id="label-8" class="form-control radio-group radio-xs-12 radio-md-6">-->
											<!--		<div class="radio-row">-->
											<!--			<div class="standard-radio radio-xs-3"><label for="label-8-1"><input name="label8" type="radio" id="label-8-1" value="1">1</label>-->
											<!--			</div>-->
											<!--			<div class="standard-radio radio-xs-3"><label for="label-8-2"><input name="label8" type="radio" id="label-8-2" value="2">2</label>-->
											<!--			</div>-->
											<!--			<div class="standard-radio radio-xs-3"><label for="label-8-3"><input name="label8" type="radio" id="label-8-3" value="3">3</label>-->
											<!--			</div>-->
											<!--			<div class="standard-radio radio-xs-3"><label for="label-8-4"><input name="label8" type="radio" id="label-8-4" value="4">4</label>-->
											<!--			</div>-->
											<!--		</div>-->
											<!--		<div class="radio-row">-->
											<!--			<div class="standard-radio radio-xs-3"><label for="label-8-5"><input name="label8" type="radio" id="label-8-5" value="5">5</label>-->
											<!--			</div>-->
											<!--			<div class="standard-radio radio-xs-3"><label for="label-8-6"><input name="label8" type="radio" id="label-8-6" value="6">6</label>-->
											<!--			</div>-->
											<!--			<div class="standard-radio radio-xs-3"><label for="label-8-7"><input name="label8" type="radio" id="label-8-7" value="7">7</label>-->
											<!--			</div>-->
											<!--			<div class="standard-radio radio-xs-3"><label for="label-8-8"><input name="label8" type="radio" id="label-8-8" value="8">8</label>-->
											<!--			</div>-->
											<!--		</div>-->
											<!--		<div class="radio-row">-->
											<!--			<div class="standard-radio radio-xs-3"><label for="label-8-9"><input name="label8" type="radio" id="label-8-9" value="9">9</label>-->
											<!--			</div>-->
											<!--			<div class="standard-radio radio-xs-3"><label for="label-8-10"><input name="label8" type="radio" id="label-8-10" value="10">10</label>-->
											<!--			</div>-->
											<!--			<div class="standard-radio radio-xs-3"><label for="label-8-11"><input name="label8" type="radio" id="label-8-11" value="11">11</label>-->
											<!--			</div>-->
											<!--			<div class="standard-radio radio-xs-3"><label for="label-8-12"><input name="label8" type="radio" id="label-8-12" value="12">12</label>-->
											<!--			</div>-->
											<!--		</div>-->
											<!--	</div>-->
											<!--</div>-->

											<input
												v-else-if="sim.tipo == 'data' && sim.show"
												type="date" v-model="risposteUtente[sim.id]"
												:name="`risposte[${index}]`"
												class="form-control"
												autocomplete="off"
												tabindex="1"
											>
											
											<template v-else-if="(
												sim.tipo == 'checkbox'
												|| sim.tipo == 'checkbox_bloccante'
												|| sim.tipo == 'checkbox_reverse'
												) && sim.show"
											>
												<input
													type="checkbox"
													:id="`${sim.id}_${index}`"
													v-model="risposteUtente[sim.id]"
												>
												<label :for="`${sim.id}_${index}`">{{ `${sim.domanda} *` }}</label>
											</template>

											<div v-else-if="sim.tipo == 'summary' && sim.show">
												<div style="font-size: 18px; margin-bottom: 10px">Riepilogo dati inseriti</div>
												<div class="mb-3">
													<div
														v-for="item in summaryData"
														class="mb-3"
													>
														<span class="font-weight-bold mr-2">
															{{ item.domanda}}:
														</span>
														<span>
															{{
																typeof item.rispostaUtente == 'boolean'
																	? (item.rispostaUtente == true ? 'Si' : 'No')
																	: item.rispostaUtente
															}}
														</span>
													</div>
												</div>

												<div class="font-weight-bold mt-6">
													Informativa: I dati inseriti potrebbero essere oggetto di verifica durante la lavorazione della domanda.
												</div>
												
												<div class="mb-6">
													<input
														type="checkbox"
														:id="`${sim.id}_${index}`"
														v-model="risposteUtente[sim.id]"
													>
													<label :for="`${sim.id}_${index}`">Accetto *</label>
												</div>

												<div>Cliccare sul pulsante <span class="font-weight-bold">Indietro</span> per modificare i dati inseriti</div>
												<div>Cliccare sul pulsante <span class="font-weight-bold">{{ tastoContinuaVisibile ? 'Continua' : 'Invia'}}</span> per confermare i dati inseriti ed inviare la domanda</div>
											</div>
											
										</div>

										<!--<div>* Campo obbligatorio</div>-->

									</div>
								</fieldset>
								
								<div class="d-flex justify-space-between mt-10">
									<div class="d-flex justify-start">
										<input
											@click="goBack()"
											:disabled="isLeftingSimulazione"
											type="button"
											value="Esci"
											class="btn"
										>
									</div>
									
									<div class="d-flex justify-end">
										<input
											v-if="tastoIndietroVisibile"
											@click="setDomandeESchermataDaMostrare('indietro')"
											type="button"
											value="Indietro"
											title="Indietro"
											class="btn mr-5 simulazione-step-7"
											tabindex="3"
										>
										
										<input
											type="button"
											v-show="tastoContinuaVisibile"
											@click="continuaOppureInvia(false, 'avanti')"
											:disabled="checkboxesBloccantiAttive"
											value="Continua"
											class="btn simulazione-step-4"
											tabindex="2"
										>
										
										<input
											v-if="!stoInviandoLaSimulazione"
											type="button"
											v-show="tastoInviaVisibile"
											@click="continuaOppureInvia(true)"
											:disabled="checkboxesBloccantiAttive"
											value="Invia"
											class="btn btn-green simulazione-step-6"
											tabindex="2"
										>
										
										<input
											v-else-if="stoInviandoLaSimulazione"
											type="button"
											disabled
											v-show="tastoInviaVisibile"
											value="Invia"
											class="btn pull-right mr-15"
											tabindex="2"
										>
									</div>
								</div>
							</v-form>
						</div>

						<div v-if="eseguitaSimulazioneConGuida" class="page-overlay"></div>

						<v-dialog persistent v-model="eseguitaSimulazioneConGuida" max-width="504px">
							<v-col class="pa-4 white--text" style="background-color:#002e5f">
                  <span class="title">
                    Complimenti, hai completato la guida!
                  </span>
								<br><br>
								<span class="title">
                    Adesso clicca su OK per tornare alla Pagina Iniziale ed eseguire la tua prima vera simulazione!
                  </span>
								<div class="ok-button-wrapper">
									<a class="ok-button" href="/home">OK</a>
								</div>
							</v-col>
						</v-dialog>

					</template>
				</div>
			</div>

			<footer>
				2022 INAIL - ISTITUTO NAZIONALE PER L'ASSICURAZIONE CONTRO GLI INFORTUNI SUL LAVORO
			</footer>
			
			<!--<v-tour name="explanatoryTour" :steps="tourSteps" :options="tourOptions" :callbacks="tourCallbacks">-->
			<!--	<template slot-scope="tour">-->
			<!--		<transition name="fade">-->
			<!--			<v-step-->
			<!--				v-if="tour.currentStep === index"-->
			<!--				v-for="(step, index) of tour.steps"-->
			<!--				:key="index"-->
			<!--				:step="step"-->
			<!--				:previous-step="tour.previousStep"-->
			<!--				:next-step="tour.nextStep"-->
			<!--				:stop="tour.stop"-->
			<!--				:is-first="tour.isFirst"-->
			<!--				:is-last="tour.isLast"-->
			<!--				:labels="tour.labels"-->
			<!--				style="max-width: 600px"-->
			<!--				:highlight="tour.highlight"-->
			<!--			>-->
			<!--			</v-step>-->
			<!--		</transition>-->
			<!--	</template>-->
			<!--</v-tour>-->

			<!--<v-dialog v-model="isDatiCliccatoreDialogOpen" width="920">-->
			<!--	<v-card min-width=900 max-width=900>-->
			<!--		<v-card-title class="headline">-->
			<!--			&lt;!&ndash; <span class="ml-4">DATI CLICCATORE</span> &ndash;&gt;-->
			<!--			<v-spacer></v-spacer>-->
			<!--			<v-btn color="black&#45;&#45;text" icon @click="isDatiCliccatoreDialogOpen = false">-->
			<!--				<v-icon>close</v-icon>-->
			<!--			</v-btn>-->
			<!--		</v-card-title>-->
			<!--		<v-card-text>-->
			<!--			<div :style="`margin:0 10px 20px; color:${scdOrange}; font-weight:500;`">-->
			<!--				ATTENZIONE:<br>Questa finestra contiene i dati personali che possono essere richiesti durante le simulazioni. Devi quindi copiarli e incollarli in un blocco note per averli a portata di mano durante gli allenamenti.-->
			<!--			</div>-->
			<!--			<dati-cliccatore-component v-if="isDatiCliccatoreDialogOpen" :IdUtenteProp="computedIdUtente"/>-->
			<!--		</v-card-text>-->
			<!--		<v-card-actions>-->
			<!--			<v-spacer></v-spacer>-->
			<!--			<v-btn :color="scdColor" style="text-transform:none; padding:0 20px; color:white;" depressed rounded class="mr-4 mb-3" @click="isDatiCliccatoreDialogOpen = false">Chiudi</v-btn>-->
			<!--		</v-card-actions>-->
			<!--	</v-card>-->
			<!--</v-dialog>-->

		</div>
	</div>
</template>

<script>
import mixin from '../../mixins';
import { uuid } from 'vue-uuid';

export default {
	// props: ['id'],
	data() {
		return {
			onlyViewMode: false,
			
			alertType: null,
			message: null,

			errorMessage: null,

			valid: false,

			gameDayId: null,
			idCliccatore: this.computedIdUtente,

			isCliente: false,
			isProvaGratuita: false,
			isCliccatore: false,

			isLeftingSimulazione: false,

			isLoadingDatiGameday: false,

			status: null,
			nomeGameday: null,

			datiSimulazione: {
				id: null,
				dataOra: null,
				simulazione: [],
				simulazioneConRisposteSenzaShuffle: [],
				// startIndex: 0,
				// endIndex: null,
				simulazioneGuidata: false
			},
			schermataAttuale: 0,
			maxSchermate: 0,

			simulazioniTerminate: false,

			// bandoId: null,

			risposteUtente: {
				// Le informazioni inserite dall'utente
				// verranno identificate attraverso un uuid generato nella funzione getDatiSimulazione()

				// uuid (stringa) : risposta dell'utente (stringa)
				// "3df85a92-a0f1-4ca3-9b4a-8b67e91cc467" : risposta
			},

			// ECGHD
			sequence: {
				char1: null,
				char2: null,
				char3: null,
				char4: null,
				char5: null
			},

			showTooltip: false,

			// A causa della diversa formattazione della data, metto qua le risposte pronte ad essere confrontate con quelle del database
			risposteUtentePerIlConfronto: {},

			tastoContinuaVisibile: true,
			tastoIndietroVisibile: false,
			tastoInviaVisibile: false,

			// Inserisco il Csrf Token presente nei META
			csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),

			// Tour guidato al primo accesso:
			eseguitaSimulazioneConGuida: false,

			tourSteps: [],
			tourOptions: {
				useKeyboardNavigation: false,
				labels: {
					buttonSkip: 'Salta guida',
					buttonPrevious: 'Precedente',
					buttonNext: 'Successivo',
					buttonStop: 'Fine'
				},
				highlight: true
			},
			tourCallbacks: {
				onPreviousStep: this.vaiAllaPaginaPrecedente,
				onNextStep: this.vaiAllaPaginaSuccessiva,
				onStop: this.utentePuoInteragire
			},
			currentStep: 2,
			tourInEsecuzione: false,

			ripetiGuida: false,

			isDatiCliccatoreDialogOpen: false,

			isDialogAcquistoRicaricheAperta: false,
			
			stoInviandoLaSimulazione: false,
			
			risposteCorrette: {
				// uuid (stringa) : risposta corretta
				// "3df85a92-a0f1-4ca3-9b4a-8b67e91cc467" : risposta corretta
			},

		};
	},

	created() {
		this.gameDayId = window.__GAMEDAY_ID__;
		this.onlyViewMode = window.__ONLY_VIEW_MODE__;
		
		if (!this.isTheBrowserCompatible() && !this.onlyViewMode) {
			this.errorMessage = 'Browser non compatibile';
			return;
		}
		
		this.getDatiGameDay();
		
		// TODO: rimuovo i precedenti gameday, poi devo eliminare questa riga
		// for (let i = 1; i <= 20; i++) {
		// 	localStorage.removeItem(`risultatoSimulazioneGameDay${i}`);
		// }
	},
	
	computed: {
		orarioSimulazione() {
			return moment(this.datiSimulazione.dataOra, "YYYY-MM-DD hh:mm:ss").format('HH:mm:ss');
		},
		annoMeseGiornoSimulazione() {
			return moment(this.datiSimulazione.dataOra, "YYYY-MM-DD hh:mm:ss").format('YYYY-MM-DD');
		},
		checkboxesBloccantiAttive() {
			return this.datiSimulazione.simulazione.some(domandaObj => {
				return domandaObj.show === true
					&& (domandaObj.tipo == 'checkbox_bloccante' || domandaObj.tipo == 'summary')
					&& this.risposteUtente[domandaObj.id] !== this.risposteCorrette[domandaObj.id]
			});
		},
		summaryData() {
			return this.datiSimulazione.simulazione
				.filter(domandaObj => domandaObj.tipo != 'summary')
				.filter(domandaObj => domandaObj.schermata < this.schermataAttuale)
				.map(domandaObj => ({
				domanda: domandaObj.domanda,
				rispostaUtente: this.risposteUtente[domandaObj.id]
			}))
		}
	},
	
	methods: {
		getDatiGameDay() {
			this.isLoadingDatiGameday = true;
			const url = this.onlyViewMode
				? `/clickdayit/ottieni-dati-simulazione-gameday/${this.gameDayId}?only_view_mode=true`
				: `/clickdayit/ottieni-dati-simulazione-gameday/${this.gameDayId}`;
			
			axios.get(url)
				.then(response => {
					this.datiSimulazione.id = response.data.simulazione.id;
					this.datiSimulazione.dataOra = response.data.simulazione.dataOra;
					
					// le domande le ho ordinate per schermata usando un metodo di Laravel
					this.datiSimulazione.simulazioneConRisposteSenzaShuffle = response.data.simulazione.simulazioneConRisposteSenzaShuffle; // copia esatta del database
					this.datiSimulazione.simulazione = response.data.simulazione.simulazione;
					
					// for (let i = 0; i < this.datiSimulazione.simulazione.length; i++) {
					// 	console.log('domanda shuffle', this.datiSimulazione.simulazioneConRisposteSenzaShuffle[i].domanda);
					// 	console.log('domanda', this.datiSimulazione.simulazione[i].domanda);
					//
					// 	console.log('risposte shuffle', this.datiSimulazione.simulazioneConRisposteSenzaShuffle[i].risposte);
					// 	console.log('risposte', this.datiSimulazione.simulazione[i].risposte);
					//
					// 	console.log('schermata shuffle', this.datiSimulazione.simulazioneConRisposteSenzaShuffle[i].schermata);
					// 	console.log('schermata', this.datiSimulazione.simulazione[i].schermata);
					// }
					
					this.maxSchermate = response.data.simulazione.maxSchermate;
					
					this.setVariabiliAccessorie();
					this.setRisposteCorrette();

					this.status = response.data.status;
					this.nomeGameday = response.data.nome_gameday;

					this.schermataAttuale = 0;
					if (this.status == 'started' || this.status == 'only_view_mode') {
						this.setDomandeESchermataDaMostrare('avanti');
					}
					// this.startSimulazioneTour();
				})
				.catch(error => {
					this.errorMessage = error.response.data.message;
					// if (error.response.status == 403) this.$router.push({ name: 'gaming-route' });
					// console.log(error.response)
				})
				.finally(() => {
					this.isLoadingDatiGameday = false;
				})
		},
		setVariabiliAccessorie() {
			this.datiSimulazione.simulazione.forEach(domanda => {
				this.$set(domanda, 'id', this.$uuid.v4()); // assegno un id univoco ad ogni domanda
				
				// nell'oggetto delle risposte da inviare per il controllo, per ogni domanda creo una chiave univoca con lo stesso nome dell'id creato nella riga precedente
				if (domanda.tipo == 'checkbox'
					|| domanda.tipo == 'checkbox_bloccante'
					|| domanda.tipo == 'summary'
				) {
					this.$set(this.risposteUtente, domanda.id, false); // reactive
					this.$set(this.risposteUtentePerIlConfronto, domanda.id, false); // reactive
				}
				else if (domanda.tipo == 'checkbox_reverse') {
					this.$set(this.risposteUtente, domanda.id, true); // parte già spuntata
					this.$set(this.risposteUtentePerIlConfronto, domanda.id, true); // parte già spuntata
				}
				else {
					this.$set(this.risposteUtente, domanda.id, null); // reactive
					this.$set(this.risposteUtentePerIlConfronto, domanda.id, null); // reactive
				}
				
				this.$set(domanda, 'rispostaNonCorretta', false); // reactive
				this.$set(domanda, 'show', false); // reactive
			});
		},
		setRisposteCorrette() {
			for (const key in this.datiSimulazione.simulazione) {
				let UUIDSimulazione = this.datiSimulazione.simulazione[key].id;
				this.$set(this.risposteCorrette, UUIDSimulazione, this.datiSimulazione.simulazioneConRisposteSenzaShuffle[key].risposte[0]); // reactive
			}
		},
		setDomandeESchermataDaMostrare(direzione) {
			this.setSchermataAttuale(direzione);

			let maxCicliEmergenza = 0;
			let domandeTrovatePerSchermataAttuale = false;
			while (!domandeTrovatePerSchermataAttuale) {
				for (let i = 0; i < this.datiSimulazione.simulazione.length; i++) {
					if (this.datiSimulazione.simulazione[i].schermata == this.schermataAttuale) {
						this.datiSimulazione.simulazione[i].show = true;
						domandeTrovatePerSchermataAttuale = true;
					} else if (this.datiSimulazione.simulazione[i].schermata != this.schermataAttuale) {
						this.datiSimulazione.simulazione[i].show = false;
					}
				}

				if (!domandeTrovatePerSchermataAttuale) {
					this.setSchermataAttuale(direzione);
				}

				// visibilità pulsanti
				if (this.schermataAttuale > 1) {
					this.tastoIndietroVisibile = true;
				} else if (this.schermataAttuale == 1) {
					this.tastoIndietroVisibile = false;
				}

				if (this.schermataAttuale == this.maxSchermate) {
					this.tastoContinuaVisibile = false;
					this.tastoInviaVisibile = true;
				} else if (this.schermataAttuale < this.maxSchermate) { // nel back-end ho impostato massimo 4 schermate
					this.tastoContinuaVisibile = true;
					this.tastoInviaVisibile = false;
				}

				maxCicliEmergenza++;
				if (maxCicliEmergenza == 50) {
					break;
				}

			}
		},
		setSchermataAttuale(direzione) {
			if (direzione == 'avanti' && this.schermataAttuale < this.maxSchermate) {
				this.schermataAttuale++;
			} else if (direzione == 'indietro' && this.schermataAttuale > 1) {
				this.schermataAttuale--;
			}
		},
		tornaAllaPrimaSchermata() {
			this.schermataAttuale = 0;
			this.setDomandeESchermataDaMostrare('avanti');
		},
		// abbandona: function() {
		// 	// Avviso il server di segnare la simulazione come abbandonata, e poi torno indietro
		// 	this.isLeftingSimulazione = true;
		//
		// 	const url = `/clickdayit/abbandona-simulazione-gameday/${this.datiSimulazione.id}`
		// 	axios.get(url)
		// 		.then(response => {
		// 			window.location.href = "/home#/gaming";
		// 		})
		// 		.catch(error => {
		// 			console.log(error);
		// 		})
		// 		.finally(() => {
		// 			this.isLeftingSimulazione = false;
		// 		});
		// },
		continuaOppureInvia: function(inviaForm, direzione) {
			// creo un oggetto con le risposte corrette
			// uuid (stringa) : risposta (number)
			for (const key in this.datiSimulazione.simulazione) {
				let UUIDSimulazione = this.datiSimulazione.simulazione[key].id;
				
				if (this.datiSimulazione.simulazione[key].tipo == 'data'
					&& moment(this.risposteUtente[UUIDSimulazione], "YYYY-MM-DD", true).isValid()
				) {
					this.risposteUtentePerIlConfronto[UUIDSimulazione] = moment(this.risposteUtente[UUIDSimulazione], "YYYY-MM-DD").format('DD/MM/YYYY');
				} else {
					this.risposteUtentePerIlConfronto[UUIDSimulazione] = this.risposteUtente[UUIDSimulazione];
				}
			}
			
			if (!inviaForm) {
				this.setDomandeESchermataDaMostrare(direzione);
				return;
			}
			
			let errorFound = false;
			let schermataInCuiHoTrovatoIlPrimoErrore = null;
			
			if (inviaForm) {
				for (const key in this.datiSimulazione.simulazione) {
					let domandaObj = this.datiSimulazione.simulazione[key];
					
					if (this.risposteCorrette[domandaObj.id] != this.risposteUtentePerIlConfronto[domandaObj.id]) {
						errorFound = true;
						domandaObj.rispostaNonCorretta = true;
						
						if (schermataInCuiHoTrovatoIlPrimoErrore === null) {
							schermataInCuiHoTrovatoIlPrimoErrore = domandaObj.schermata;
						}
					}
					else {
						domandaObj.rispostaNonCorretta = false;
					}
				}
			}
			
			if (errorFound) {
				this.tornaAllaPrimaSchermata();
				
				// dopo essere ritornato alla prima schermata con il metodo this.tornaAllaPrimaSchermata(),
				// se il primo errore si trova in una schermata successiva alla prima, vado a vanti fino a quella schermata
				if (schermataInCuiHoTrovatoIlPrimoErrore > 1) {
					while (schermataInCuiHoTrovatoIlPrimoErrore != this.schermataAttuale) {
						this.setDomandeESchermataDaMostrare('avanti');
					}
				}
				
				// ripristino tutte le checkbox come erano in partenza (è il comportamento della pagina ufficiale inail)
				this.datiSimulazione.simulazione
					.filter(domanda => domanda.schermata >= schermataInCuiHoTrovatoIlPrimoErrore)
					.forEach(domanda => {
						if (domanda.tipo == 'checkbox'
							|| domanda.tipo == 'checkbox_bloccante'
							|| domanda.tipo == 'summary'
						) {
							this.risposteUtente[domanda.id] = false;
						}
						else if (domanda.tipo == 'checkbox_reverse') {
							this.risposteUtente[domanda.id] = true;
						}
					});
				
				return;
			}
			
			if(!errorFound && this.status != 'only_view_mode') {
				this.stoInviandoLaSimulazione = true;
				
				let formData = new FormData();
				formData.append('risposte', JSON.stringify(this.risposteUtentePerIlConfronto));
				formData.append('simulazione_id', this.datiSimulazione.id);
				// formData.append('bando_id', this.bandoId);
				// formData.append('anno_mese_giorno_simulazione', this.annoMeseGiornoSimulazione);
				axios.post('/clickdayit/esito-simulazione-gameday',
						formData,
						{
							headers: {
								'Content-Type': 'application/json'
							},
						}
					)
					.then(response => {
						if (response.data.hasError) {
							this.errorMessage = response.data.message;
						}
						else {
							// let risultatoSimulazione = {
							// 	nomeGameday: this.nomeGameday,
							// 	tempoImpiegato: response.data.tempoImpiegato,
							// 	colore: response.data.colore,
							// 	hasError: response.data.hasError,
							// 	message: response.data.message,
							// }

							// localStorage.setItem(`risultatoSimulazioneGameDay${this.datiSimulazione.id}`, JSON.stringify(risultatoSimulazione));
							// localStorage.removeItem('nonHoPremutoF5');

							window.location.href = `/game-day/${this.datiSimulazione.id}/risultato`;
						}

					})
					.catch(error => {
						this.errorMessage = error.response.data.message;
					})
			}
			// else e.preventDefault();

		},
		vaiAllaPaginaPrecedente() {
			this.currentStep--;
			if (this.currentStep == 4) {
				this.setDomandeESchermataDaMostrare('indietro');
			}
		},
		vaiAllaPaginaSuccessiva() {
			this.currentStep++;
			if (this.currentStep == 5) {
				this.setDomandeESchermataDaMostrare('avanti');
			}
		},
		utentePuoInteragire() {
			this.tourInEsecuzione = false;
			this.tornaAllaPrimaSchermata();
		},
		showDatiCliccatore(idCliccatore) {
			this.idCliccatoreToShowDati = idCliccatore;
			this.isDatiCliccatoreDialogOpen = true;
		},
		reloadPage() {
			window.location.reload()
		},
		goBack() {
			window.location.href = '/home#/gaming-game-day'
		},
		buildSequence(simId) {
			let sequence = '';
			for (const key in this.sequence) {
				sequence += this.sequence[key];
			}

			this.risposteUtente[simId] = sequence;
		},
		getSequenceBorderColor(char, index) {
			// con la nuova gestione degli errori non mostro più il colore rosso mentre si sta compilando il campo ma solo alla fine
			return '#afafaf';
			
			// if (char == null) return '#afafaf';
			// else if (index === 1) return this.sequence.char1 === 'A' ? '#afafaf' : '#ff5252';
			// else if (index === 2) return this.sequence.char2 === 'M' ? '#afafaf' : '#ff5252';
			// else if (index === 3) return this.sequence.char3 === 'T' ? '#afafaf' : '#ff5252';
			// else if (index === 4) return this.sequence.char4 === 'I' ? '#afafaf' : '#ff5252';
			// else if (index === 5) return this.sequence.char5 === 'G' ? '#afafaf' : '#ff5252';
		},
		handlePrevent(event) {
			const gamedays = [15, 25]
			if (gamedays.includes(this.datiSimulazione.id)) {
				event.preventDefault();
			}
		},
		
	},
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600&display=swap');

* {
	font-family: 'Open Sans', sans-serif !important;
}

.gameday_body {
	min-width: 489.1px;
	max-width: 1366px;
	width: auto;
	margin-right: auto;
	margin-left: auto;
	font-size: 14.4333px;
	background-color: white;
}
footer {
	//position: absolute;
	//bottom: 0;
	//left: 0;
	width: 100%;
	background-color: #002e5f;
	padding: 20px 60px 20px;
	color: #fff;
	font-size: .9em;
}
#logo-inail {
	margin-left: 60px;
	margin-bottom: 40px;
	display: block;
	width: 176px;
	height: 56px;
}
#logo-inail img {
	width: 176px;
}
h1 {
	display: none
}
h2 {
	margin-top: 0;
}
h3 {
	margin: 0;
	margin-bottom: 30px;
	text-transform: uppercase;
	font-weight: 400;
	font-size: 16.5px;
}
h4 {
	font-size: 1.25em;
	margin-top: 10px;
	margin-bottom: 25px;
	font-weight: 500;
	line-height: 1.1;
}
fieldset {
	margin: 0;
	padding: 0;
	border: 0;
}
p {
	margin-bottom: 10px;
}
header {
	padding: 60px 60px 40px 60px;
	border-bottom: 20px solid #002e5f;
}
.main {
	border-top: 20px solid #1E6665;
	padding: 30px;
}
.main h2 {
	color: #002e5f;
	margin-bottom: 30px;
	font-family: 'Open Sans semibold', sans-serif;
	font-size: 23.8333px;
	font-weight: 500;
}
.mr-15 {
	margin-right: 15px;
}
.form-gray {
	background-color: #f2f2f2;
	padding: 35px 30px;
}
.form-elem {
	margin-bottom: 20px;
}
.form-elem .msg {
	position: relative;
	top: 5px;
	display: none;
}
.form-elem input:not([type="checkbox"]):not([type="radio"]),
.form-elem select {
	width: 100%;
	border: 1px solid #afafaf;
	background-color: #fff;
	height: 34px;
	box-sizing: border-box;
	padding: 6px 12px;
}
.form-elem input:focus, .form-elem select:focus {
	outline: 0;
	border-color: #66afe9;
	box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, .6);
}
.form-elem label {
	margin-bottom: 5px;
	display: inline-block;
}
.form-elem.errore .msg {
	display: block;
}
.form-elem.errore input:focus, .form-elem.errore select:focus {
	box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #ce8483;
}
.form-elem.errore input,
.form-elem.errore select {
	border-color: #c9291b !important;
	/* border-color: #C9291B; */
}
.form-elem.errore label, .testo-errore {
	color: #ff5252 ;
	/* color: #C9291B; */
}
.form-elem.date-elem label {
	display: block;
}
.form-elem.date-elem input{
	width: 200px;
}
.btn {
	background-color: #002e5f;
	color: #fff;
	text-transform: uppercase;
	border-radius: 0;
	border: 0;
	min-width: 160px;
	font-weight: 400;
	padding: 6px 12px;
	line-height: 1.92857em;
	cursor: pointer;
	&.abbandona {
		background-color: #bc2025;
	}
	&.dati-personali {
		background-color: #e6901c;
	}
	&.btn-green {
		background-color: #0e821a;
	}
}
.btn-row {
	height: 40px;
	margin-top: 40px;
}
.btn[disabled] {
	pointer-events: none;
	cursor: not-allowed;
	box-shadow: none;
	background: #d2d2d2;
	border-color: #d2d2d2;
	color: #002e5f;
	opacity: 1 !important;
}

.btn:focus, input[type=checkbox]:focus, .feedback:focus {
	outline: thin dotted;
	outline-offset: -2px;
}
input[type=checkbox] {
	margin: 0;
	margin-right: 5px;
	top: 3px;
	position: relative;
}
.pull-right {
	float: right;
}
.xs-12 {
	width: 100%;
}

.titolo {
	margin-top: 15px;
	margin-bottom: 25px;
	font-weight: 700;
	font-size: 24px;
	color: #002e5f;
}

::v-deep ._radio_group label,
::v-deep ._checkbox label {
	animation: none !important;
}

/*SM*/
@media (min-width: 768px) {}
/*MD*/
@media (min-width: 992px) {
	.md-3 {
		width: 25%;
	}
	.md-6 {
		// width: 50%;
		width: 100%;
	}
}

/*LG*/
@media (min-width: 1200px) {}
.loader-overlay {
	position: fixed;
	background-color: #002E5F;
	background-color: rgba(0, 46, 95, 0.2);
	width:100%;
	height:100%;
	top:0;
	left: 0;
	opacity: 1;
	z-index: 500000;
}
.loader-overlay span{
	position: fixed; /* or absolute */
	top: 50%;
	left: 50%;
	border: 10px solid #106CDB; /* Light grey */
	border-top: 10px solid #002e5f; /* Blue */
	border-radius: 50%;
	width: 60px;
	height: 60px;
	animation: spin 2s linear infinite;
}
@keyframes spin {
	0% { transform: rotate(0deg); }
	100% { transform: rotate(360deg); }
}
.data-summary strong {
	width: 200px;
	display: inline-block;
}

.avviso-finale-prova {
	position: absolute;
	bottom: 200px;
	left: 50%;
	transform: translate(-50%, -50%);
}
.page-overlay {
	position: absolute;
	top:0;
	right:0;
	bottom:0;
	left:0;
	background-color: rgba(0, 0, 0, 0.50);
}

.tour-2-3 {
	width: 100%;
}
@media (min-width: 992px) {
	.tour-2-3 {
		width: 50%;
	}
}

.ok-button-wrapper {
	display: flex;
	justify-content: flex-end;
	padding-top: 20px;
}
.ok-button {
	color: #002e5f;
	font-size: 20px;
	text-decoration: none;
	padding: 5px 10px;
	background-color: white;
	border-radius: 3px;
}

// aggiunte per i radio buttons
//.standard-radio {
//	margin-top: 10px;
//	float: left;
//}
//.standard-radio label {
//	margin-left: 0px;
//	font-weight: normal;
//}
//.margin-top-20 {
//	margin-top: 20px;
//}
//.radio-row::after, .form-group::after {
//	clear: both;
//}
//.radio-row::before, .radio-row::after, .form-group::before, .form-group::after {
//	display: table;
//	content: " ";
//}
//.radio-xs-3 {
//	width: 25%;
//	float: left;
//}
//.radio-xs-12 {
//	width: 100%;
//}
//.radio-md-6 {
//	width: 50%;
//	float: left;
//}
</style>